import apiClient from "../Api/ApiClient"

export const UserLoginCheck = async (payload) => {
    console.log("Login Payload:", payload);
    try {
        const response = await apiClient.post('/api/Auth/login', {
            userName: payload.username,
            password: payload.password
        });

        const data = response.data;
        console.log("Login Response Data:", data);

        // The API now returns the complete user object
        return {
            token: data.token,
            refreshToken: data.refreshToken,
            userId: data.userId,
            userName: data.userName,
            employeeId: data.employeeId,
            branchId: data.branchId,
            companyId: data.companyId,
            currencyCode: data.currencyCode,
            user: {
                user_Id: data.userId,
                user_UserName: data.userName,
                user_IsAdmin: data.isAdmin,
                user_Active: data.isActive,
                user_Branch_Id: data.branchId,
                user_EmployeeId: data.employeeId,
                user_Company_Id: data.companyId,
                currencyCode: data.currencyCode
            },
            currencyCode: data.currencyCode,
            isAdmin: data.isAdmin
        };
    } catch (error) {
        console.error("Error in login:", error.response?.data || error.message);
        // Extract error message from various possible response formats
        const errorMessage = error.response?.data?.message
            || error.response?.data
            || error.message
            || "Invalid username or password. Please try again.";
        throw new Error(errorMessage);
    }
};

export const refreshToken = async (token, refreshToken) => {
    try {
        const response = await apiClient.post('/api/Auth/refresh-token', {
            token: token,
            refreshToken: refreshToken
        });

        const data = response.data;
        return {
            accessToken: data.token,
            refreshToken: data.refreshToken,
            currencyCode: data.currencyCode
        };
    } catch (error) {
        console.error("Error refreshing token:", error);
        throw error;
    }
};

export const changePassword = async (payload) => {
    console.log("Change Password Payload:", payload);
    try {
        const response = await apiClient.post('/api/Auth/change-password', {
            username: payload.username,
            currentPassword: payload.currentPassword,
            newPassword: payload.newPassword
        });

        const data = response.data;
        console.log("Change Password Response Data:", data);

        return {
            success: true,
            message: data.message || "Password changed successfully"
        };
    } catch (error) {
        console.error("Error in change password:", error.response?.data?.message || error.message);
        throw new Error(error.response?.data?.message || "Password change failed. Please try again.");
    }
};
